import { useGet, useRest } from 'react-common';
import '../styles/PresentationTab.css';
import { useCallback, useEffect, useState } from 'react';
import { List, ListItemButton, ListItemText, MenuItem, Select } from '@mui/material';
import { FallbackMessage } from 'ds-form';
import { useTranslation } from 'react-i18next';

const PresentationTab = ({activeSlideshowID, presentedSlide, setPresentedSlide}) => {

    const { t } = useTranslation();
    const [activePresentationID, setActivePresentationID] = useState('');
    const [presentedSlides, setPresentedSlides] = useState([]);
    const { getData } = useRest();

    const [presentations = []] = useGet("Presentations", {
        params : {
            slideshowID: activeSlideshowID
        },
        transform: (res) => {
            return res.records || [];
        }
    });

    const getPresentedSlides = useCallback(() => {
        getData("PresentedSlides", {presentationID: activePresentationID})
            .then((result) => {
                setPresentedSlides(result.records?.map((s, index) => ({ ...s, title: 'Slide ' + (index + 1) })))
            })
            .catch(err => {
                console.log(err)
            })
    }, [getData, activePresentationID])

    useEffect(() => {
        if(activePresentationID){
            getPresentedSlides()   
        }
    }, [activePresentationID, getPresentedSlides])

    useEffect(() => {
        setPresentedSlide()
        setActivePresentationID()
        setPresentedSlides()
    }, [activeSlideshowID, setPresentedSlide])

    useEffect(() => {
        setPresentedSlide()
    }, [activePresentationID, setPresentedSlide])

    return (
        <div className="presentationTab">
            <div className="presentationSelectContainer">
                <Select
                    value={activePresentationID}
                    onChange={(event) => setActivePresentationID(event.target.value)}
                    className="slideshowSelect"
                    displayEmpty
                    renderValue={() => {
                        if (activePresentationID) {
                            return <em>{activePresentationID}</em>
                        } 
                        return <em>{t("selectPresentation")}</em>;
                    }}
                >
                    {!presentations.length ?
                        <div className="fallbackMessageContainer">
                            <FallbackMessage >{t("slideshowAccess")}</FallbackMessage>  
                        </div>
                        :
                        presentations.map((presentation) => (
                            <MenuItem 
                                key={presentation.id} 
                                value={presentation.id}
                            >
                                {presentation.id}
                            </MenuItem>
                        ))
                    }
                </Select>
            </div>
            <div>
                {presentedSlides && presentedSlides.length > 0 &&
                    <List>
                        {presentedSlides.map((slide) => (
                            <ListItemButton 
                                selected={presentedSlide ? slide.id === presentedSlide.id : false} 
                                key={slide.id} 
                                onClick={() => setPresentedSlide(slide)}
                            >
                                <ListItemText primary={slide.title} />
                            </ListItemButton>
                        ))}
                    </List>
                }
            </div>
        </div>
    )
}

export default PresentationTab;